import { useState } from 'react'
import { Card } from 'react-bootstrap'
import { Title } from '../../../../Templates/Title'
import { GiMoneyStack } from 'react-icons/gi'
import { BsPencil } from 'react-icons/bs'
import { EditPaymentScaleModal } from './components/EditPaymentScaleModal'


export const PaymentScale = () => {
    const [show, setShow] = useState(false)

    return (
        <div className='d-flex flex-column w-100'>
            <EditPaymentScaleModal show={show} onHide={() => setShow(false)} />
            <Title title='Escala de Pagos' icon={<GiMoneyStack
                size={30} />} subtitle={'Configura una explicación de como se efectuarán los pagos y los montos de los mismos acorde a tus preferencias.'} />
            <Card className='mb-2' style={{ width: 'fit-content' }}>
                <Card.Body>
                    <div className='d-flex align-items-center gap-2 text-primary text-sm' role='button' onClick={() => setShow(true)}>
                        Editar explicación escala de pagos
                        <BsPencil className='text-primaryy' />

                    </div>
                </Card.Body>

            </Card>
        </div>
    )
}
